import { Link } from 'react-router-dom';

export default function SobrePage() {
  return (
    <main className="pt-24" data-testid="sobre-page">
      {/* Hero */}
      <section className="section">
        <div className="page-container">
          <div className="max-w-3xl">
            <span className="label-mono mb-4 block">Sobre</span>
            <h1 className="heading-display mb-8">
              Rafael Pinto
            </h1>
            <p className="body-text text-lg">
              Chamo-me Rafael Pinto. Tenho 31 anos, vivo no Porto, 
              e trabalho com pessoas que precisam de pensar com mais clareza 
              e decidir com maior estrutura.
            </p>
          </div>
        </div>
      </section>

      {/* Percurso */}
      <section className="section section-muted" data-testid="percurso-section">
        <div className="page-container">
          <div className="max-w-2xl space-y-6">
            <p className="body-text">
              Licenciado em Criminologia em 2016, desisti do Mestrado no primeiro 
              mês quando conheci o coaching e o desenvolvimento pessoal. Vi ali 
              uma forma concreta de fazer um trabalho que me ocupava a cabeça 
              há muito tempo: ajudar pessoas a pensar sobre si com mais clareza 
              e menos ruído. Tirei duas certificações internacionais em 2017, 
              em Coaching e em PNL.
            </p>
            <p className="body-text">
              Comecei a trabalhar com clientes aos 22, em paralelo com um 
              part-time numa loja de desporto. Entre o final de 2018 e maio 
              de 2019 fiz uma experiência de voluntariado internacional, 
              e foi ao regressar que assumi o coaching a tempo inteiro. 
              Nos cinco anos seguintes acumulei cerca de quinhentas horas 
              de sessões individuais, duzentas horas a guiar uma comunidade 
              online, e bastante trabalho de escrita e criação de conteúdo.
            </p>
            <p className="body-text">
              Em 2024 parei. Não porque o trabalho não estivesse a correr, 
              mas porque se estava a tornar claro que faltava maturidade, 
              profundidade e estrutura ao que conseguia oferecer sozinho. 
              Entrei na BGA — uma escola internacional onde acompanho jovens 
              a pensar, planear e decidir, articulando a vida académica com 
              os seus interesses, hobbies e o futuro que querem construir — 
              e mantive o trabalho privado em segundo plano. Esses dois anos 
              serviram para aprofundar a prática e mudar a forma como me 
              apresento: bases mais alicerçadas, frameworks mais resistentes, 
              capacidade de pensar com mais nuance do que tinha antes.
            </p>
          </div>
        </div>
      </section>

      {/* O que me interessa */}
      <section className="section" data-testid="interesse-section">
        <div className="page-container">
          <div className="max-w-2xl">
            <span className="label-mono mb-4 block">O que me interessa</span>
            <p className="body-text mb-6">
              O que me interessa neste trabalho não é dar respostas. 
              É desarmar perspetivas, abrir espaço para nuance, ajudar 
              quem está à minha frente a sair do pensamento corrente 
              e a ver o seu próprio funcionamento com mais distância.
            </p>
            <p className="body-text mb-6">
              Trabalho melhor com pessoas racionais, exigentes, dispostas 
              a serem desafiadas e a estarem desconfortáveis.
            </p>
            <p className="body-text">
              Não trabalho com quem procura respostas rápidas, muletas 
              emocionais ou validação. Também não trabalho com quem procura 
              estatuto, ou se refugia nele, porque o estatuto esconde mais 
              do que revela e anula potencial de crescimento.
            </p>
          </div>
        </div>
      </section>

      {/* Pessoal */}
      <section className="section section-muted" data-testid="pessoal-section">
        <div className="page-container">
          <div className="max-w-2xl">
            <p className="body-text">
              Vivo no Porto com a minha mais-que-tudo, a Mafalda. Temos uma cadela que se chama Willow e o
              nosso primeiro filho, o Guilherme, nasceu em julho deste ano.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="page-container">
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contacto" className="btn-primary" data-testid="cta-conversa">
              Iniciar Conversa
            </Link>
            <Link to="/acompanhamentos" className="btn-outline" data-testid="cta-acompanhamentos">
              Ver Acompanhamentos
            </Link>
          </div>
        </div>
      </section>
    </main>);

}
